export default __webpack_public_path__ + "static/media/op_amp.3fce2816.svg";